import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
const initialState = {
  usersFilter: {
    startDate: '',
    endDate: '',
    location: '',
    type: '',
    // '' = no filter, 'visible' = actually showing in the app right now,
    // 'hidden' = not blocked but not showing (e.g. a practitioner whose
    // premium lapsed) or blocked. Backed by the appVisibility param added
    // to GET /admin/users.
    visibility: '',
  },

  bookingsFilter: {
    startDate: '',
    endDate: '',
  },

  classesFilter: {
    startDate: '',
    endDate: '',
  },
}

const slice = createSlice({
  name: 'filter',
  initialState: initialState,
  reducers: {
    setUsersType: (state, action) => {
      state.usersFilter = {
        ...state.usersFilter,
        type: action.payload,
      }
    },
    setUserLocation: (state, action) => {
      state.usersFilter = {
        ...state.usersFilter,
        location: action.payload,
      }
    },
    setUserStartDate: (state, action) => {
      state.usersFilter = {
        ...state.usersFilter,
        startDate: action.payload,
      }
    },
    setUserEndDate: (state, action) => {
      state.usersFilter = {
        ...state.usersFilter,
        endDate: action.payload,
      }
    },
    setUserVisibility: (state, action) => {
      state.usersFilter = {
        ...state.usersFilter,
        visibility: action.payload,
      }
    },
    setClassesStartDate: (state, action) => {
      state.classesFilter = {
        ...state.classesFilter,
        startDate: action.payload,
      }
    },
    setClassesEndDate: (state, action) => {
      state.classesFilter = {
        ...state.classesFilter,
        endDate: action.payload,
      }
    },

    setBookingStartDate: (state, action) => {
      state.bookingsFilter = {
        ...state.bookingsFilter,
        startDate: action.payload,
      }
    },
    setBookingEndDate: (state, action) => {
      state.bookingsFilter = {
        ...state.bookingsFilter,
        endDate: action.payload,
      }
    },
  },
})

export const {
  setUsersType,
  setUserLocation,
  setUserStartDate,
  setUserEndDate,
  setUserVisibility,
  setClassesStartDate,
  setClassesEndDate,
  setBookingStartDate,
  setBookingEndDate,
} = slice.actions
export default slice.reducer
